module.exports = __webpack_public_path__ + "img/ico_consultant.2fb5c504.png";